<template>
  <el-form-item
    :label="item.label"
    :prop="`${item.field}`"
    :hidden="item.options.hidden"
    v-if="item.showed"
    :rules="[
      {
        required: item.required || false,
        message: item.label + '为必填字段',
      },
    ]"
  >
    <el-cascader v-model="$attrs.model[item.field]" :options="item.options.valueData" :style="{ width: item.options.width }"></el-cascader>
  </el-form-item>
</template>

<script>
export default {
  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped></style>
